import './App.css';
import Razrjesenja from './Razrjesenja';
import * as d3 from "d3";

function App() {
  return (
    <Razrjesenja vladeJoin={vladeJoin} />
  );
}

const vladeJoin = [
  {
    premijer: "Ivica Račan",
    start: d3.utcParse("%d.%m.%Y")("27.3.2000"),
    end: d3.utcParse("%d.%m.%Y")("23.12.2003"),
    ostavke: [
      { name: "Ivan Jakovčić", date: d3.utcParse("%d.%m.%Y")("21.6.2001") },
      {
        name: "Stjepan Ivanišević",
        date: d3.utcParse("%d.%m.%Y")("27.9.2001"),
      },
      {
        name: "Ana Stavljenić Rukavina",
        date: d3.utcParse("%d.%m.%Y")("23.10.2001"),
      },
      { name: "Goran Granić", date: d3.utcParse("%d.%m.%Y")("21.3.2002") },
      { name: "Goranko Fižulić", date: d3.utcParse("%d.%m.%Y")("21.3.2002") },
      { name: "Alojz Tušek", date: d3.utcParse("%d.%m.%Y")("21.3.2002") },
      { name: "Božo Kovačević", date: d3.utcParse("%d.%m.%Y")("7.7.2003") },
    ],
  },
  {
    premijer: "Ivo Sanader",
    start: d3.utcParse("%d.%m.%Y")("23.12.2003"),
    end: d3.utcParse("%d.%m.%Y")("6.7.2009"),
    ostavke: [
      { name: "Andrija Hebrang", date: d3.utcParse("%d.%m.%Y")("15.2.2005") },
      { name: "Miomir Žužul", date: d3.utcParse("%d.%m.%Y")("15.2.2005") },
      { name: "Marijan Mlinarić", date: d3.utcParse("%d.%m.%Y")("12.7.2005") },
      { name: "Vesna Škare Ožbolt", date: d3.utcParse("%d.%m.%Y")("9.2.2006") },
      { name: "Ivica Kirin", date: d3.utcParse("%d.%m.%Y")("2.1.2008") },
      { name: "Ana Lovrin", date: d3.utcParse("%d.%m.%Y")("10.10.2008") },
    ],
  },
  {
    premijer: "Jadranka Kosor",
    start: d3.utcParse("%d.%m.%Y")("6.7.2009"),
    end: d3.utcParse("%d.%m.%Y")("23.12.2011"),
    ostavke: [
      { name: "Damir Polančec", date: d3.utcParse("%d.%m.%Y")("30.10.2009") },
      { name: "Bianca Matković", date: d3.utcParse("%d.%m.%Y")("24.10.2009") },
      { name: "Ivica Ivanišević", date: d3.utcParse("%d.%m.%Y")("7.7.2010") },
      { name: "Đurđa Adlešić", date: d3.utcParse("%d.%m.%Y")("12.10.2010") },
      { name: "Ivan Šuker", date: d3.utcParse("%d.%m.%Y")("29.12.2010") },
      { name: "Božo Biškupić", date: d3.utcParse("%d.%m.%Y")("29.12.2010") },
      { name: "Branko Vukelić", date: d3.utcParse("%d.%m.%Y")("29.12.2010") },
      {
        name: "Marina Matulović-Dropulović",
        date: d3.utcParse("%d.%m.%Y")("29.12.2010"),
      },
      {
        name: "Jagoda Premužić",
        date: d3.utcParse("%d.%m.%Y")("7.12.2011"),
      },
    ],
  },
  {
    premijer: "Zoran Milanović",
    start: d3.utcParse("%d.%m.%Y")("23.12.2011"),
    end: d3.utcParse("%d.%m.%Y")("22.1.2016"),
    ostavke: [
      { name: "Zlatko Komadina", date: d3.utcParse("%d.%m.%Y")("18.4.2012") },
      { name: "Mirela Holy", date: d3.utcParse("%d.%m.%Y")("13.6.2012") },
      { name: "Radomir Čačić", date: d3.utcParse("%d.%m.%Y")("14.11.2012") },
      { name: "Veljko Ostojić", date: d3.utcParse("%d.%m.%Y")("19.3.2013") },
      { name: "Neven Mimica", date: d3.utcParse("%d.%m.%Y")("1.7.2013") },
      { name: "Slavko Linić", date: d3.utcParse("%d.%m.%Y")("14.5.2014") },
      {
        name: "Željko Jovanović",
        date: d3.utcParse("%d.%m.%Y")("18.6.2014"),
      },
      {
        name: "Rajko Ostojić",
        date: d3.utcParse("%d.%m.%Y")("18.6.2014"),
      },
      {
        name: "Andrea Zlatar-Violić",
        date: d3.utcParse("%d.%m.%Y")("25.3.2015"),
      },
    ],
  },
  {
    premijer: "Tihomir Orešković",
    start: d3.utcParse("%d.%m.%Y")("22.1.2016"),
    end: d3.utcParse("%d.%m.%Y")("19.10.2016"),
    ostavke: [
      { name: "Mijo Crnoja", date: d3.utcParse("%d.%m.%Y")("28.1.2016") },
      {
        name: "Tomislav Karamarko",
        date: d3.utcParse("%d.%m.%Y")("15.6.2016"),
      },
      { name: "Božo Petrov", date: d3.utcParse("%d.%m.%Y")("13.10.2016") },
      { name: "Tomislav Panenić", date: d3.utcParse("%d.%m.%Y")("13.10.2016") },
    ],
  },
  {
    premijer: "Andrej Plenković",
    start: d3.utcParse("%d.%m.%Y")("19.10.2016"),
    end: new Date(),
    ostavke: [
      { name: "Vlaho Orepić", date: d3.utcParse("%d.%m.%Y")("27.4.2017") },
      {
        name: "Slaven Dobrović",
        date: d3.utcParse("%d.%m.%Y")("27.4.2017"),
      },
      { name: "Ante Šprlje", date: d3.utcParse("%d.%m.%Y")("27.4.2017") },
      { name: "Ivan Kovačić", date: d3.utcParse("%d.%m.%Y")("28.4.2017") },

      { name: "Pavo Barišić", date: d3.utcParse("%d.%m.%Y")("9.6.2017") },
      { name: "Davor Ivo Stier", date: d3.utcParse("%d.%m.%Y")("19.6.2017") },
      { name: "Martina Dalić", date: d3.utcParse("%d.%m.%Y")("14.5.2018") },
      { name: "Lovro Kuščević", date: d3.utcParse("%d.%m.%Y")("9.7.2019") },
      { name: "Goran Marić", date: d3.utcParse("%d.%m.%Y")("16.7.2019") },
      {
        name: "Marija Pejčinović Burić",
        date: d3.utcParse("%d.%m.%Y")("19.7.2019"),
      },
      { name: "Nada Murganić", date: d3.utcParse("%d.%m.%Y")("19.7.2019") },
      { name: "Tomislav Tolušić", date: d3.utcParse("%d.%m.%Y")("19.7.2019") },
      { name: "Gabrijela Žalac", date: d3.utcParse("%d.%m.%Y")("19.7.2019") },
      { name: "Milan Kujundžić", date: d3.utcParse("%d.%m.%Y")("28.1.2020") },
      { name: "Damir Krstičević", date: d3.utcParse("%d.%m.%Y")("14.5.2020") },
      { name: "Darko Horvat", date: d3.utcParse("%d.%m.%Y")("19.2.2022") },
      {
        name: "Josip Aladrović",
        date: d3.utcParse("%d.%m.%Y")("27.4.2022"),
      },
      {
        name: "Tomislav Ćorić",
        date: d3.utcParse("%d.%m.%Y")("27.4.2022"),
      },
      { name: "Zdravko Marić", date: d3.utcParse("%d.%m.%Y")("7.7.2022") },
    ],
  },
];

export default App;
